module.exports = __webpack_public_path__ + "static/media/Menu.b6141fbc.png";